import { SocketAPI } from './api/index';
import React, { useEffect, useState } from "react"
import { AppState, ActivityIndicator } from 'react-native';
import Colors from '../constants/colors';

type SocketManagerProps = {
    access_token?:string,
    distinct_id?:string,
    onConnect:() => void,
    onDisconnect:() => void,
    group_id?:string,
    onSocketEvent:(event:any) => void,
    subscribed_events: string[]
}

const SocketManager = ({ access_token, distinct_id, group_id, onSocketEvent, subscribed_events, onConnect, onDisconnect }:SocketManagerProps) => {
    const [ visible, setVisible ] = useState(true);
    const [ ws, setWs ] = useState<any>();
    const [ connected, setConnected ] = useState(false);
    const [ authenticated, setAuthenticated ] = useState(false);
    const [ active_chat, setActiveChat ] = useState<string|undefined>(undefined);

    useEffect(() => {
        SocketAPI.setEnvironment();
        AppState.addEventListener('change', handleEventChange)
        return () => {
            console.log('closed!!!')
        }
    },[]);

    useEffect(() => {
        if(!authenticated){ return }
        if(!access_token || !distinct_id){ return }
        if(group_id){ joinChat(access_token, distinct_id, group_id) }
        if(!group_id && active_chat){ leaveChat(access_token, distinct_id) }
    },[authenticated, group_id])

    useEffect(() => {

        if(visible){ 
           if(!ws || ws.readyState != 1) { return connectSocket(access_token, distinct_id) }
           if(access_token && distinct_id){ 
            socketAuthenticate(access_token, distinct_id) 
        }
        }
        else {
            if(ws){ ws.close() }
        }
    },[visible, access_token, distinct_id])


    const handleEventChange = (state:string) => {
        if(state == 'active'){ setVisible(true) }
        else { setVisible(false) }
    }

    const connectSocket = (access_token?:string, distinct_id?:string) => {
        let new_ws = SocketAPI.socketConnect();
        let sub:any = undefined
        new_ws.onopen = async() => {
            setConnected(true)
            onConnect();
            new_ws.send(JSON.stringify({ type: 'PING', data: new Date().toTimeString() }));
            if(access_token && distinct_id){
                new_ws.send(JSON.stringify({
                    type: 'AUTHENTICATE',
                    access_token,
                    device_id: distinct_id
                }));
                setAuthenticated(true);
            }
        }

        new_ws.onmessage = (body:any) => {
            let message = JSON.parse(body.data);
            if(message.type == 'PONG' && new_ws && new_ws.readyState == 1){ 
                setTimeout(() => { 
                    if(new_ws && new_ws.readyState == 1){
                        new_ws.send(JSON.stringify({ type: 'PING', data: new Date().toTimeString() })) 
                    }
                }, 10000); 
            }
            if(subscribed_events.includes(message.type)){ onSocketEvent(message) }
        }
        new_ws.onclose = () => {
            //setWs(undefined);
            if(sub){ sub.remove() }
            setConnected(false);
            setAuthenticated(false);
            setActiveChat(undefined);
            onDisconnect();
        }
        setWs(new_ws);
    }

    const joinChat = (access_token:string, device_id:string, group_id:string) => {
        if(!ws || ws.readyState !== 1){ return } //Cannot set authenticate without a connected websocket
        console.log('joining chat!')
        ws.send(JSON.stringify({
            type: 'JOIN_CHAT',
            access_token,
            device_id,
            group_id
        }));
        setActiveChat(group_id);
    }

    const leaveChat = (access_token:string, device_id: string) => {
        if(!active_chat){ return }
        ws.send(JSON.stringify({
            type: 'LEAVE_CHAT',
            access_token,
            device_id,
            group_id: active_chat
        }))
    }

    const socketAuthenticate = (access_token:string, device_id:string) => {
        if(!ws || ws.readyState !== 1){ return } //Cannot set authenticate without a connected websocket
        ws.send(JSON.stringify({
            type: 'AUTHENTICATE',
            access_token,
            device_id
        }))
        setAuthenticated(true);
    }
    if(ws && connected){ return <></> }
    return (
        <ActivityIndicator style={{ position:'absolute', bottom:5, right:5 }} size='large' color={Colors.brand.midnight}/>
    )
    
}

export default SocketManager